import { render } from "./InventoryHistory.vue?vue&type=template&id=79f7a4a3&scoped=true"
import script from "./InventoryHistory.vue?vue&type=script&lang=js"
export * from "./InventoryHistory.vue?vue&type=script&lang=js"

import "./InventoryHistory.vue?vue&type=style&index=0&id=79f7a4a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f7a4a3"]])

export default __exports__